import cloneDeep from 'lodash/cloneDeep';

import { DELETE_PATIENT_RESULT } from '../../../../actions/action-types';
import {
  ADD_PATIENT,
  ADD_PATIENT_ERROR,
  ADD_PATIENT_RESULT,
  ADD_TIMER_TASK_RESULT,
  CLEAR_DEVICE_DATA,
  END_TASK,
  END_TASK_ERROR,
  END_TASK_RESULT,
  EVENT_LIST,
  EVENT_LIST_ERROR,
  EVENT_LIST_RESULT,
  GET_CAP_DETAILS,
  GET_CAP_DETAILS_ERROR,
  GET_CAP_DETAILS_RESULT,
  GET_DEVICES,
  GET_DEVICES_DETAILS,
  GET_DEVICES_DETAILS_ERROR,
  GET_DEVICES_DETAILS_RESULT,
  GET_DEVICES_ERROR,
  GET_DEVICES_RESULT,
  GET_MEDICATIONS,
  GET_MEDICATIONS_ERROR,
  GET_MEDICATIONS_RESULT,
  PATIENT_DETAILS,
  PATIENT_DETAILS_RESULT,
  PATIENT_LIST,
  PATIENT_LIST_CLEAR,
  PATIENT_LIST_RESULT,
  START_TASK,
  START_TASK_ERROR,
  START_TASK_RESULT,
  GET_NOTES,
  GET_NOTES_RESULT,
  GET_NOTES_ERROR,
  PATIENT_BILLABLE_TIME_RESULT,
  PATIENT_LIST_FOR_SUGGESTION_RESULT,
  PATIENT_LIST_FOR_SUGGESTION_CLEAR,
  GET_CONDITION_LIST,
  GET_CONDITION_LIST_ERROR,
  GET_CONDITION_LIST_RESULT,
  GET_READINGS,
  GET_READINGS_RESULT,
  GET_READINGS_ERROR,
  PATIENT_DETAILS_CLEAR,
  SET_ORG_FILTER,
  GET_TIMER_TASKS_LIST,
  GET_TIMER_TASKS_LIST_ERROR,
  GET_TIMER_TASKS_LIST_RESULT,
  PATIENT_BILLABLE_TIME,
  PATIENT_BILLABLE_TIME_ERROR,
  CLEAR_PATIENT_BILLABLE_TIME,
  TASK_HISTORY_LIST,
  TASK_HISTORY_LIST_ERROR,
  TASK_HISTORY_LIST_RESULT,
} from './constants';
import { isLatestResult } from '../../../../middleware/latest';

export const CapPatientsReducer = (state = {}, action) => {
  switch (action.type) {
    case START_TASK:
    case GET_TIMER_TASKS_LIST:
    case ADD_PATIENT:
    case GET_DEVICES_DETAILS:
    case GET_CAP_DETAILS:
      return {
        ...state,
        isLoading: true,
      };

    case END_TASK:
      return {
        ...state,
        isEndTaskLoading: true,
      };

    case GET_MEDICATIONS:
      return {
        ...state,
        patientMedications: [],
        patientMedicationsLoaded: false,
        isPatientMedicationsLoading: true,
      };

    case PATIENT_LIST:
      return {
        ...state,
        data: undefined,
        isLoading: true,
        patientListRequestId: action.latestRequestId,
      };

    case START_TASK_ERROR:
    case GET_TIMER_TASKS_LIST_ERROR:
    case ADD_PATIENT_ERROR:
    case GET_DEVICES_DETAILS_ERROR:
    case GET_CAP_DETAILS_ERROR:
      return {
        ...state,
        isLoading: false,
        isEndTaskLoading: false,
      };
    case GET_MEDICATIONS_ERROR:
      return {
        ...state,
        isPatientMedicationsLoading: false,
        patientMedicationsLoaded: false,
      };

    case ADD_PATIENT_RESULT:
      return {
        ...state,
        isLoading: false,
      };
    case START_TASK_RESULT:
      return {
        ...state,
        isLoading: false,
      };
    case END_TASK_RESULT:
      return {
        ...state,
        isEndTaskLoading: false,
        endTaskData: action.response,
      };

    case ADD_TIMER_TASK_RESULT:
      return {
        ...state,
        addTimerTaskData: action.response,
      };

    case END_TASK_ERROR:
      return {
        ...state,
        isEndTaskLoading: false,
      };

    case PATIENT_LIST_RESULT:
      if (!isLatestResult(state.patientListRequestId, action)) {
        return state;
      }
      return {
        ...state,
        isLoading: false,
        data: action.response,
      };

    case EVENT_LIST:
      return {
        ...state,
        isPatientEventsLoading: true,
      };

    case EVENT_LIST_ERROR:
      return {
        ...state,
        isPatientEventsLoading: false,
      };

    case EVENT_LIST_RESULT:
      return {
        ...state,
        isPatientEventsLoading: false,
        patientEvents: action.response,
        pagination: action.response.pagination,
      };

    case GET_DEVICES_DETAILS_RESULT:
      return {
        ...state,
        isLoading: false,
        patientDeviceDetails: action.response,
        pagination: action.response.pagination,
      };

    case GET_CAP_DETAILS_RESULT:
      return {
        ...state,
        isLoading: false,
        patientCapDetails: action.response,
        pagination: action.response.pagination,
      };

    case GET_TIMER_TASKS_LIST_RESULT:
      return {
        ...state,
        isLoading: false,
        taskList: action.response,
      };
    case PATIENT_BILLABLE_TIME:
    case PATIENT_BILLABLE_TIME_ERROR:
    case CLEAR_PATIENT_BILLABLE_TIME:
      return {
        ...state,
        taskStatus: undefined,
      };
    case PATIENT_BILLABLE_TIME_RESULT:
      return {
        ...state,
        isLoading: false,
        taskStatus: {
          loggedTime: action.response.billable_time,
          goal: action.response.billable_time < 20 * 60 ? 20 : (action.response.billable_time < 40 * 60 ? 40 : 60),
        },
      };
    case PATIENT_DETAILS:
      return {
        ...state,
        isLoadingPatientDetails: true,
      };
    case PATIENT_DETAILS_RESULT:
      return {
        ...state,
        isLoadingPatientDetails: false,
        patientDetails: action.response,
      };
    case PATIENT_DETAILS_CLEAR:
      return {
        ...state,
        patientDetails: undefined,
      };
    case GET_MEDICATIONS_RESULT:
      return {
        ...state,
        isPatientMedicationsLoading: false,
        // The schedule list is only trustworthy after a successful fetch: it is emptied on request and stays empty on error.
        patientMedicationsLoaded: true,
        patientMedications: action.response,
      };

    case TASK_HISTORY_LIST:
      return {
        ...state,
        isTaskHistoryListLoading: true,
      };
    case TASK_HISTORY_LIST_ERROR:
      return {
        ...state,
        isTaskHistoryListLoading: false,
      };
    case TASK_HISTORY_LIST_RESULT:
      return {
        ...state,
        isTaskHistoryListLoading: false,
        taskHistoryList: action.response,
        pagination: action.response.pagination,
      };

    case GET_DEVICES:
      return {
        ...state,
        isPatientDevicesLoading: true,
        patientDevicesRequestId: action.latestRequestId,
      };

    case GET_DEVICES_ERROR:
      if (!isLatestResult(state.patientDevicesRequestId, action)) {
        return state;
      }
      return {
        ...state,
        isPatientDevicesLoading: false,
      };

    case GET_DEVICES_RESULT:
      if (!isLatestResult(state.patientDevicesRequestId, action)) {
        return state;
      }
      return {
        ...state,
        isPatientDevicesLoading: false,
        patientDevices: action.response,
      };

    case PATIENT_LIST_CLEAR:
      return {
        ...state,
        isLoading: false,
        data: undefined,
      };
    case PATIENT_LIST_FOR_SUGGESTION_RESULT:
      return {
        ...state,
        patientsForSuggestion: action.response.data,
      };
    case PATIENT_LIST_FOR_SUGGESTION_CLEAR:
      return {
        ...state,
        patientsForSuggestion: [],
      };

    case DELETE_PATIENT_RESULT: {
      if (action.id) {
        const { data } = state;

        let updatedPatients = cloneDeep(data);
        updatedPatients.data = data?.data.filter(patient => {
          return patient.id !== action.id;
        });

        return {
          ...state,
          data: updatedPatients,
          isLoading: false,
        };
      }
    }

    case CLEAR_DEVICE_DATA:
      return {
        ...state,
        isLoading: false,
        isPatientDevicesLoading: false,
        patientDevices: CLEAR_DEVICE_DATA,
      };

    case GET_NOTES:
      return {
        ...state,
        notes: [],
      };

    case GET_NOTES_RESULT:
      return {
        ...state,
        notes: action.response.data,
      };

    case GET_NOTES_ERROR:
      return {
        ...state,
        notes: [],
      };

    case GET_CONDITION_LIST:
      return {
        ...state,
        conditions: [],
      };

    case GET_CONDITION_LIST_RESULT:
      return {
        ...state,
        conditions: action.response.data,
        //pagination: action.response.pagination,
      };

    case GET_CONDITION_LIST_ERROR:
      return {
        ...state,
        conditions: [],
      };

    case GET_READINGS:
      return {
        ...state,
        readings: [],
        isLoading: true,
      };

    case GET_READINGS_RESULT:
      return {
        ...state,
        readings: action.response.data,
        pagination: action.response.pagination,
        isLoading: false,
      };

    case GET_READINGS_ERROR:
      return {
        ...state,
        readings: [],
        isLoading: false,
      };

    case SET_ORG_FILTER:
      return {
        ...state,
        orgFilter: {
          ...state.orgFilter,
          [action.userId]: action.orgId
        },
      };

    default:
      return state;
  }
};
